/*
 * @Descripttion: 公共组件  注册全局组件
 * @version: 
 * @Author: wl
 * @Date: 2020-05-22 16:41:38
 * @LastEditors: wl
 * @LastEditTime: 2020-07-07 17:51:26
 */ 
import page from './Template/PageTemplate.vue'

export default(Vue) =>{
    Vue.component('page', page)
}

/* 页面布局组件 */


let commonComponent=[
    
]


// WEBPACK FOOTER //
// ./src/components/index.js